// src/components/FundingGuideLayout.jsx
import React from "react";

const FundingGuideLayout = ({ children }) => {
  return (
    <div className="w-full bg-gray-50/20 min-h-[calc(100vh-4rem)] flex flex-col">
      {/* Semantic Content Container Hub - Safe spacing clearance built in */}
      <article className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12 mt-4">
        
        {/* Inner Flex/Grid layout allowing child blocks and sticky components to live side-by-side */}
        <div className="w-full transition-all duration-300 ease-in-out">
          {children}
        </div>

      </article>

      {/* Global Minimalist Footer Layer for Multi-Currency Asset Guides */}
      <footer className="w-full border-t border-gray-100 bg-white py-6 mt-auto text-center text-xs font-semibold text-gray-400 tracking-wider">
        <p>© 2026 InvestorLanes Portal. All sovereign investment corridor materials reserved.</p>
      </footer>
    </div>
  );
};

export default FundingGuideLayout;
